export default function offerCartOptionsResolver({ offer, offerSettings, itemSettings, on }) {
    return {
        bind: {
            offer: offer,
            settings: offerSettings.cart,
            isCartCountAvailable: offerSettings.isCartCountAvailable,
            labelAsCartIcon: itemSettings.labelAsCartIcon,
        },
        on: {
            'add-to-cart-click': on.addToCartClick,
            'remove-from-cart-click': on.removeFromCartClick,
        },
    };
}
